import LinkToDocusaurus from '../LinkToDocusaurus'

const LinkToReleaseDocumentation  = () =>
  <LinkToDocusaurus path='dai-release-notes-v26-1'>
    Learn more in documentation
  </LinkToDocusaurus>

export default LinkToReleaseDocumentation